import irelandApi from '../irelandApi';

const getFeatures = () => dispatch =>
  irelandApi
    .get('/api/features')
    .then(({ data }) =>
      dispatch({ type: 'FEATURES_LOADED', payload: data }))
    .catch(() => dispatch({ type: 'FEATURES_FAILED' }));

export default getFeatures;
